"use client";

import React from "react";
import Marquee from "react-fast-marquee";

import "./universityslider.css";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";

const Universityslider = () => {
  const universities = [
    {
      image: "/assets/images/university-slider/1782972531610.webp",
      alt: "DPU",
    },

    {
      image:
        "/assets/images/university-slider/1766396486942-NMIMS University.webp",
      alt: "NMIMS University",
    },

    {
      image:
        "/assets/images/university-slider/1766396583600-Manipal University.webp",
      alt: "Manipal University",
    },

    {
      image:
        "/assets/images/university-slider/1766396558563-Sikkim Manipal University.webp",
      alt: "Sikkim Manipal University",
    },

    {
      image: "/assets/images/university-slider/Atlas-Skilltech-University.jpg",
      alt: "atlas university",
    },

    {
      image:
        "/assets/images/university-slider/1766396532768-Amity University.webp",
      alt: "Amity University",
    },
    
    {
      image:
        "/assets/images/university-slider/1766396607252-Chandigarh University.webp",
      alt: "Chandigarh University",
    },

    {
      image: "/assets/images/university-slider/Lpu-online-1-300x150-1.png",
      alt: "LPU online",
    },
  ];

  return (
    <section className="university-slider-section">
      {" "}
      <div className="container-fluid">
        <Main_heading_holder
          heading="Top Institutes for  "
          spanHeading="Online MBA, BBA in India"
          subHeading="We are authorized academic partners with India's leading UGC-recognized universities, serving as their Online MBA Academic Advisors and guiding your journey every step of the way."
          headingType="h2"
        />

        {/* <div className="new_swiper_holder">
          <Marquee speed={40} gradient={false} pauseOnHover>
            <div className="new_brands_holder">
              {universities.map((university, index) => (
                <div className="logo-div" key={index}>
                  <img
                    src={university.image}
                    className="uni-img"
                    alt={university.alt}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </Marquee>
        </div> */}

        <div className="university-grid container">
          {universities.map((university, index) => (
            <div className="university-card" key={index}>
              <img
                src={university.image}
                alt={university.alt}
                className="uni-img"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Universityslider;
